import type { GroupingGroup } from '@vedalib/editor/lib/elements'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import cn from 'classnames'
import { useContext } from 'use-context-selector'

import GroupingContext from 'components/Editor/EditorElements/elements/Grouping/GroupingContext'
import { borderRadiusContent } from 'components/Editor/EditorElements/elements/Grouping/helper'
import { useProjectT } from 'services/ProjectLabels'
import { useUrlByUsage } from 'utils/files'

import Mask from '../../Mask/Mask'
import * as s from './Group.module.scss'

interface ICardProps {
  activeId: string
  group: GroupingGroup
  isCorrect: boolean
  onAssign: (groupId: string) => void
}

const Group = ({ activeId, group, isCorrect, onAssign }: ICardProps) => {
  const pt = useProjectT()
  const { styles, hasGroupImage, font, feedback } = useContext(GroupingContext)
  const imgUrl = useUrlByUsage(group.target.image, FileUsageTypeEnum.image)
  const labelClasses = cn(s.label, { [s.placeholder]: !group.target.label })

  const label =
    group.target.label || (group?.target.image?.id && hasGroupImage)
      ? group.target.label || ''
      : pt('elements.grouping.group.placeholder')

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onAssign(group.value)
    }
  }

  return (
    <div>
      <div
        aria-label={label || pt('elements.grouping.group.placeholder')}
        className={cn(s.group, { [s.card]: hasGroupImage })}
        id={group.value}
        onClick={() => onAssign(group.value)}
        onKeyDown={handleKeyDown}
        role='button'
        style={{
          ...styles.group,
          ...font?.base,
          padding: styles.indents.padding,
          backgroundImage: imgUrl && hasGroupImage ? `url(${imgUrl})` : undefined,
        }}
        tabIndex={0}
      >
        <div className={s.mask} style={{ backgroundColor: group.target.overlay || undefined }} />
        {activeId === group.value && (
          <Mask
            borderRadius={borderRadiusContent(styles.group) || styles.group.borderRadius}
            feedback={feedback}
            isCorrect={isCorrect}
          />
        )}
        <span className={labelClasses}>{label}</span>
      </div>
    </div>
  )
}
export default Group
